import { progressApi as api } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getPointCloudImages = (id: number) => {
  const url = `/PointCloud/GetPointCloudImages${extractedPath}?pointCloudId=${id}`;
  return api.get(url);
};

export const processDroneImages = () => {
  return api.get(`/PointCloud/ProcessDroneImages${extractedPath}`);
};

export const processVolumesData = () => {
  return api.get(`/PointCloud/ProcessPlannedVolumeCalculation${extractedPath}`);
};

export const getProjectDatesInfo = () => {
  return api.get(`/PointCloud/GetProject${extractedPath}`);
};

export const setProjectDates = (data: { start: string, end: string }) => {
  return api.post(`/PointCloud/UpdateProjectStartEndDate${extractedPath}`, data);
};

export const refreshProcessing = (id: number) => {
  return api.get(`/PointCloud/CheckImageProcessStatus${extractedPath}?id=${id}`);
};

export const deletePointCloud = (id: number) => {
  return api.get(`/PointCloud/DeletePointCloud${extractedPath}?id=${id}`);
};

export const rerunProcessing = (id: number) => {
  return api.get(`/PointCloud/ProcessPointCloud${extractedPath}?pointCloudId=${id}`);
};